'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactIntl = require('react-intl');

var _baseAuthorLink = require('@bibliocommons/base-author-link');

var _baseAuthorLink2 = _interopRequireDefault(_baseAuthorLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ByAuthorBlock(_ref) {
  var _ref$authors = _ref.authors,
      authors = _ref$authors === undefined ? _immutable2.default.List() : _ref$authors,
      _ref$target = _ref.target,
      target = _ref$target === undefined ? '_parent' : _ref$target,
      _ref$renderAsLink = _ref.renderAsLink,
      renderAsLink = _ref$renderAsLink === undefined ? true : _ref$renderAsLink,
      reciprocalRank = _ref.reciprocalRank,
      props = _objectWithoutProperties(_ref, ['authors', 'target', 'renderAsLink', 'reciprocalRank']);

  if (authors.length || authors.count()) {
    return _react2.default.createElement(
      'span',
      _extends({ className: 'cp-by-author-block' }, props),
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'by_authors',
        values: {
          authorLinks: _react2.default.createElement(_baseAuthorLink2.default, {
            authors: authors,
            target: target,
            renderAsLink: renderAsLink,
            reciprocalRank: reciprocalRank })
        } })
    );
  }

  return _react2.default.createElement('noop', null);
}

ByAuthorBlock.propTypes = {
  authors: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  target: _react.PropTypes.string,
  renderAsLink: _react.PropTypes.bool,
  reciprocalRank: _react.PropTypes.number
};

ByAuthorBlock.displayName = 'ByAuthorBlock';

exports.default = ByAuthorBlock;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-by-author-block/lib/components/ByAuthorBlock.component.js
// module id = 1179
// module chunks = 0